var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostListItemFeedbackALink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.267 2.928l.758-.758a3.578 3.578 0 015.055 0 3.578 3.578 0 010 5.055l-.758.758a3.58 3.58 0 01-4.5.455l-.607.606a3.58 3.58 0 01-.454 4.5l-.758.758a3.578 3.578 0 01-5.055 0 3.578 3.578 0 010-5.055l.758-.758a3.58 3.58 0 014.498-.455l.607-.608a3.58 3.58 0 01.456-4.498zm1.602 4.463l.925-.925a.715.715 0 00-1.011-1.01l-.925.924a2.148 2.148 0 01.42-2.44l.758-.759a2.147 2.147 0 013.033 0 2.147 2.147 0 010 3.033l-.759.758c-.659.66-1.644.8-2.441.419zM6.157 9.08a2.148 2.148 0 00-2.44.419l-.758.758a2.147 2.147 0 000 3.033 2.147 2.147 0 003.033 0l.758-.758c.66-.66.799-1.645.419-2.442l-.925.925a.715.715 0 01-1.01-1.011l.923-.924z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "89efc9b0c13a823b9f61caafaaeecda3.svg";
export { SvgPostListItemFeedbackALink as ReactComponent };